module.exports = "<div class=\"footer-component\">\r\n    <div class=\"footer-component__copyright\">\r\n        <p><strong>&copy 2018 </strong>- André Lorenz</p>\r\n    </div>\r\n    <div class=\"footer-component__social\">\r\n        <a ui-sref=\"contact\" class=\"social__contact\">Contato</a>\r\n        <a ng-href=\"https://github.com/AndreLorenz\" target=\"blank\" class=\"social__git\">gh</a>\r\n        <a ng-href=\"https://linkedin.com/in/andreelorenz\" target=\"blank\" class=\"social__linked\">in</a>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./components/footer/footer.html
// module id = 92
// module chunks = 0